<div class='equipment-id'>
	<!-- Title -->
	<span class="sub-item">Home </span>
	<h2 class="ui primary header">Login</h2>
</div>

<div class="ui divider" appMargin marginY="3"></div>



<div class="ui  segment text-left"  fxLayout="row" fxLayoutAlign="space-between stretch" id="board" appPadding paddingX="15" paddingT="10">

		<div fxFlex="45%" fxHide.xs="true"  fxHide.sm="true"   fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-between center" >
			<div>
				<span><svg width="230" height="389" viewBox="0 0 230 459" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M107.722 418.2L24.0191 229.354C22.709 226.44 19.2153 224.983 16.1584 226.294L14.7027 226.877C11.7913 228.189 10.3356 231.686 11.6457 234.746L95.3482 423.591C96.6584 426.506 100.152 427.963 103.209 426.651L104.665 426.069C107.722 424.611 109.032 421.114 107.722 418.2Z" fill="#4B369D"/>
					<path d="M26.7848 223.817L92.1456 27.8315C93.1646 24.7715 91.4178 21.4201 88.3608 20.2543L86.9051 19.8172C83.8481 18.7972 80.5 20.5458 79.3355 23.6058L13.9747 219.591C12.9557 222.651 14.7026 226.003 17.7595 227.169L19.2152 227.606C22.4178 228.48 25.7659 226.877 26.7848 223.817Z" fill="#4B369D"/>
					<path d="M17.4686 247.277C8.30343 247.277 0.873627 239.84 0.873627 230.666C0.873627 221.491 8.30343 214.054 17.4686 214.054C26.6337 214.054 34.0635 221.491 34.0635 230.666C34.0635 239.84 26.6337 247.277 17.4686 247.277Z" fill="#A7ADFF"/>
					<path d="M108.304 406.543C138.874 406.543 163.621 429.711 163.621 458.271H52.9877C53.1332 429.711 77.8801 406.543 108.304 406.543Z" fill="#E3E5FC"/>
					<path d="M75.5504 5.24569C91.9998 -11.22 144.987 14.8628 193.753 63.6771L133.924 123.566C85.158 74.7514 59.101 21.8571 75.5504 5.24569Z" fill="#F3AA02"/>
					<path d="M198.702 134.203C199.43 134.203 200.158 133.911 200.74 133.329C201.759 132.309 201.759 130.56 200.595 129.54L175.266 105.351C174.247 104.331 172.5 104.331 171.481 105.497C170.462 106.517 170.462 108.266 171.626 109.286L196.956 133.474C197.247 133.911 197.975 134.203 198.702 134.203Z" fill="#E3E5FC"/>
					<path d="M170.026 159.557C170.463 159.557 170.899 159.412 171.336 159.266C172.646 158.537 173.083 156.934 172.355 155.477L155.178 124.877C154.45 123.566 152.849 123.129 151.393 123.857C150.083 124.586 149.646 126.189 150.374 127.646L167.551 158.246C168.133 158.974 169.152 159.557 170.026 159.557Z" fill="#E3E5FC"/>
					<path d="M226.506 105.934C227.671 105.934 228.69 105.206 228.981 104.186C229.563 102.729 228.836 101.126 227.38 100.689L194.772 88.0115C193.317 87.4286 191.861 88.1572 191.279 89.6143C190.696 91.0714 191.424 92.6743 192.88 93.1114L225.487 105.789C225.924 105.934 226.215 105.934 226.506 105.934Z" fill="#E3E5FC"/>
					</svg>
					</span>

		</div>
		<div class='text'>
			With an e-Services account, you can see all your transactions and records with NCC in one place.
		 </div>
		</div>

		<div fxFlex.lt-md="100%" fxFlex.lt-sm="100%"  fxFlex.lt-xs="100%" fxFlex="45%" >
			<h2 class="ui primary center aligned header">Email Verification</h2>
			<div class="ui segment  container" [ngClass]="{'loading':pending}" >

        <div class="ui attached basic fill segment" *ngIf="success">
          <div class="invite-success">
            <div class="ui success message" >
              Your account setup was successfully.
            </div>
          </div>
          <a style="margin-top:35px" class="ui primary fluid attached button" routerLink="/home-page/sign-in" [ngClass]="{'loading':pending}">
            Login
          </a>
        </div>

        <div class="ui attached basic fill segment" *ngIf="error">
          <div class="ui icon warning message">
              <i class=" info circle icon"></i>
            <div class="content">
              {{error}}
            </div>
          </div>
        </div>

			</div>

		</div>


</div>



